import { toast } from "../components/ui/use-toast";
import api from "./api";

export async function editSlide(slideId: string, doc: any) {
  try {
    const res = await api.put(`/slides/${slideId}`, doc);
    return { data: res.data, status: res.status >= 200 && res.status < 300 };
  } catch (error) {
    toast({
      title: "Error",
      description: "Failed to edit slide",
      variant: "destructive",
    });
    return { data: null, status: false };
  }
}
